import XEUtils from 'xe-utils';
import { warnLog } from '../../tools/log';
var VXECommandsStore = /** @class */ (function () {
    function VXECommandsStore() {
        this.store = {};
    }
    VXECommandsStore.prototype.mixin = function (options) {
        var _this = this;
        XEUtils.each(options, function (item, key) {
            _this.add(key, item);
        });
        return this;
    };
    VXECommandsStore.prototype.has = function (name) {
        return !!this.get(name);
    };
    VXECommandsStore.prototype.get = function (name) {
        return this.store[name];
    };
    VXECommandsStore.prototype.add = function (name, render) {
        var conf = this.store[name];
        // 兼容
        if (XEUtils.isFunction(render)) {
            if (process.env.NODE_ENV === 'development') {
                warnLog('vxe.error.delProp', ['commands -> callback', 'commandMethod']);
            }
            render = {
                commandMethod: render
            };
        }
        // 检测是否覆盖
        if (process.env.NODE_ENV === 'development') {
            var confKeys_1 = XEUtils.keys(conf);
            XEUtils.each(render, function (item, key) {
                if (confKeys_1.includes(key)) {
                    warnLog('vxe.error.coverProp', [name, key]);
                }
            });
        }
        this.store[name] = conf ? XEUtils.merge(conf, render) : render;
        return this;
    };
    VXECommandsStore.prototype.delete = function (name) {
        delete this.store[name];
    };
    VXECommandsStore.prototype.forEach = function (callback) {
        XEUtils.objectEach(this.store, callback);
    };
    return VXECommandsStore;
}());
export var commands = new VXECommandsStore();
if (process.env.NODE_ENV === 'development') {
    Object.assign(commands, { _name: 'Commands' });
}
